/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idOportunidade: string;
  idCorretorLead: string;
  idLeadCorretor: string;
  idCorretorFifty: string;
  imobiliaria?: boolean;
  nomeImobiliaria?: string;
  autonomo?: boolean;
  nomeAutonomo?: string;
  nomeCorretorFifty: string;
  clienteNaMesa: boolean;
}

export function useAprovacaoComercial(props: Props) {
  const postData = async () => {
    const APROVACAO_COMERCIAL = `${backofficeEnviroment}/common/backoffice/aprovacao-comercial/v1?`;
    const params = {
      idOportunidade: props.idOportunidade,
      idLeadCorretor: props.idLeadCorretor,
      idCorretorLead: props.idCorretorLead,
      idCorretorFifty: props.idCorretorFifty,
      nomeCorretorFifty: props.nomeCorretorFifty,
      clienteNaMesa: props.clienteNaMesa,
    };
    const params_ = props.autonomo
      ? {
          ...params,
          autonomo: props.autonomo,
          nomeAutonomo: props.nomeAutonomo,
        }
      : {
          ...params,
          imobiliaria: props.imobiliaria,
          nomeImobiliaria: props.nomeImobiliaria,
        };
    const { data } = await instance.put(APROVACAO_COMERCIAL, params_);
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Aprovação feita com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao iniciar a Aprovação. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
